module.exports = __webpack_public_path__ + "img/no-gift.c5eea80c.png";